import { render } from "./ViewProfileButtonandModal.vue?vue&type=template&id=a259701e"
import script from "./ViewProfileButtonandModal.vue?vue&type=script&lang=js"
export * from "./ViewProfileButtonandModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__